import { gql } from "@stadium/services/apollo-client";

export const FETCH_DRAFT_AUTOMATED_CATALOG = gql`
  query draftAutomatedCatalog {
    draftAutomatedCatalog {
      id
      name
      kind
      createdAt
      number
      colorGroupIds
      showDraftAutomatedMockupBanner
    }
  }
`;
